import { render, staticRenderFns } from "./CreditCardPayment.vue?vue&type=template&id=48c84376&scoped=true&"
import script from "./CreditCardPayment.vue?vue&type=script&lang=js&"
export * from "./CreditCardPayment.vue?vue&type=script&lang=js&"
import style0 from "./CreditCardPayment.vue?vue&type=style&index=0&id=48c84376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c84376",
  null
  
)

export default component.exports